export default __webpack_public_path__ + "img/4574747fd55f898dde27ff926965bfed.svg";